import type { SearchFilters } from "@little-finds/core";
export function coordinateRegionForBounds(
  bounds: NonNullable<SearchFilters["bounds"]>,
) {
  const longitudeDelta =
    bounds.east >= bounds.west
      ? bounds.east - bounds.west
      : bounds.east - bounds.west + 360;
  const longitude = bounds.west + longitudeDelta / 2;
  return {
    center: {
      latitude: (bounds.north + bounds.south) / 2,
      longitude: ((((longitude + 180) % 360) + 360) % 360) - 180,
    },
    span: {
      latitudeDelta: Math.max(0.0001, bounds.north - bounds.south),
      longitudeDelta: Math.max(0.0001, longitudeDelta),
    },
  };
}

export function mapViewport(
  latitude: number,
  longitude: number,
  west: number,
  south: number,
  east: number,
  north: number,
  zoom: number,
): Pick<SearchFilters, "center" | "bounds" | "zoom"> {
  const wrap = (value: number) => ((((value + 180) % 360) + 360) % 360) - 180;
  return {
    center: { latitude, longitude: wrap(longitude) },
    zoom,
    bounds:
      east - west >= 360
        ? undefined
        : { west: wrap(west), east: wrap(east), south, north },
  };
}
